import { useEffect, useState } from 'react';

type UseInViewOptions = IntersectionObserverInit & { once?: boolean };

export function useInView<T extends HTMLElement>(
    ref: React.RefObject<T>,
    options: UseInViewOptions = {}
): boolean {
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            setInView(entry.isIntersecting);
            if (options.once && entry.isIntersecting) {
                observer.disconnect();
            }
        }, options);
        const currentRef = ref.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        return () => {
            observer.disconnect();
        };
    }, [ref, options]);

    return inView;
}
